import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import Login from "./pages/Login/Login"
import { AuthProvider } from "./context/AuthContext"
import { ToastProvider } from "./context/ToastContext"
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute"
import GuestLayout from "./components/Layout/GuestLayout"
import DashboardLayout from "./components/Layout/DashboardLayout"
import Register from "./pages/Register/Register"
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword"
import ResetPassword from "./pages/ResetPassword/ResetPassword"
// import VerifyEmail from "./pages/VerifyEmail/VerifyEmail"
import Dashboard from "./pages/Dashboard/Dashboard"
// import Profile from "./pages/Profile/Profile"
import Toast from "./components/Toast/Toast"
import HomePage from "./components/Home/HomePage"
import SetupFlow from "./pages/Connector/SetupFlow"
import ActiveConnectors from "./pages/Connector/ActiveConnectors"
import ConnectAccountsConnectScreen from "./pages/Connector-Screen/ConnectAccounts/ConnectAccountsConnectScreen"
import ChooseSyncConnectScreen from "./pages/Connector-Screen/ChooseSync/ChooseSyncConnectScreen"
import MapFieldsConnectScreen from "./pages/Connector-Screen/MapFields/MapFieldsConnectScreen"
import SyncingProgressConnectScreen from "./pages/Connector-Screen/SyncingProgress/SyncingProgressConnectScreen"
import ReviewSyncSetupConnectScreen from "./pages/Connector-Screen/ReviewSyncSetup/ReviewSyncSetupConnectScreen"
import SyncDirectionConnectScreen from "./pages/Connector-Screen/SyncDirection/SyncDirectionConnectScreen"
import ConnectorSelectionConnectScreen from "./pages/Connector-Screen/ConnectorSelection/ConnectorSelectionConnectScreen"
import AuthSuccess from "./pages/Dashboard/AuthSuccess"
import AccountDetails from "./pages/AccountDetails/AccountDetails"
import EditConnectorScreen from "./pages/Connector-Screen/Edit-Connector-Screen/EditConnectorScreen"

const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <ToastProvider>
          <div className="App">
          <Routes>
            <Route path="/" element={<GuestLayout />}>
              <Route index element={<HomePage />} />
              <Route path="login" element={<Login />} />
              <Route path="register" element={<Register />} />
              <Route path="forgot-password" element={<ForgotPassword />} />
              <Route path="reset-password" element={<ResetPassword />} />
              {/* <Route path="/verify-email" element={<VerifyEmail />} /> */}
            </Route>

          {/*Logged In User Route*/}
          <Route path="/dashboard" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="profile" element={<AccountDetails />} />
            <Route path="account/details" element={<AccountDetails />} />
            <Route path="home" element={<Dashboard />} />
            <Route path="connectors" element={<ConnectorSelectionConnectScreen />} />
             <Route path="edit-connector/:tanentConnectorId/:tanentId" element={<EditConnectorScreen />} />
            <Route path="connect-accounts" element={<ConnectAccountsConnectScreen />} />
            <Route path="choose-sync" element={<ChooseSyncConnectScreen />} />
            <Route path="map-fields" element={<MapFieldsConnectScreen />} />
            <Route path="sync-direction" element={<SyncDirectionConnectScreen />} />
            <Route path="review-setup" element={<ReviewSyncSetupConnectScreen />} />
            <Route path="syncing-progress" element={<SyncingProgressConnectScreen />} />
            <Route path="users" element={<Dashboard />} />
            <Route path="analytics" element={<Dashboard />} />
            <Route path="settings" element={<Dashboard />} />
             <Route path="/dashboard/auth-success" element={<AuthSuccess />} />{" "}
          </Route>
           {/* Protected connector routes */}
            <Route
              path="/connector" element={<DashboardLayout />} >
              <Route path="active" element={<ActiveConnectors />} />
              <Route path="setup" element={<SetupFlow />} />
            </Route>

            {/* Catch all route */}
            <Route path="*" element={<Navigate to="/login" replace />} />

        </Routes>
            <Toast />
          </div>
        </ToastProvider>
      </AuthProvider>
    </Router>
  )
}
export default App;
